import { stepLabelClasses } from '@mui/material/StepLabel';
import { stepClasses } from '@mui/material/Step';
import { stepConnectorClasses } from '@mui/material/StepConnector';
import { stepContentClasses } from '@mui/material/StepContent';
import { colorPalette } from '../../colorPalette';
export const getStepperStyles = (sx = {}, size, variant) => {
    const sizeStyles = size === 'medium'
        ? {
            [`& .${stepConnectorClasses.vertical}`]: {
                marginLeft: '15px',
                marginTop: '-3px',
            },
            [`& .${stepClasses.vertical} `]: {
                [`& .${stepContentClasses.root}`]: {
                    marginLeft: '15px',
                    marginTop: '-3px',
                    paddingLeft: '23px',
                },
            },
            [`& .${stepClasses.horizontal} .${stepConnectorClasses.horizontal}`]: {
                top: 13,
                marginLeft: 0,
                left: 'calc(-50% + 13px)',
                right: 'calc(50% + 13px)',
            },
        }
        : {};
    const variantStyles = {
        vertical: {
            [`& .${stepContentClasses.root}`]: { borderLeft: `2px solid ${colorPalette.gray200}`, marginLeft: '11px' },
            [`& .${stepContentClasses.last}`]: { borderLeft: 'none' },
            [`& .${stepConnectorClasses.vertical}`]: {
                marginBottom: '-1px',
                marginLeft: '11px',
            },
            [`& .${stepLabelClasses.label},.${stepLabelClasses.label}.${stepLabelClasses.active},.${stepLabelClasses.label}.${stepLabelClasses.completed}`]: {
                color: colorPalette.gray700,
                fontWeight: 600,
                fontSize: '1.2rem',
                textTransform: 'uppercase',
            },
        },
        horizontal: {
            [`& .${stepLabelClasses.label}.${stepLabelClasses.alternativeLabel}`]: {
                marginTop: '8px',
                color: colorPalette.gray700,
                fontWeight: 600,
                fontSize: '1.2rem',
                textTransform: 'uppercase',
            },
        },
    };
    return Object.assign(Object.assign(Object.assign({}, variantStyles[variant]), sizeStyles), (Array.isArray(sx) ? sx : [sx]));
};
